<template>
    <footer class="footer">
        <BContainer fluid>
            <BRow>
                <BCol sm="6" class="text-center text-sm-start">
                    {{ new Date().getFullYear() }} © SteemX.com
                </BCol>
                <BCol sm="6">
                    <div class="text-sm-end d-none d-sm-block">
                        Made by FutureShock
                    </div>
                </BCol>
            </BRow>
        </BContainer>
    </footer>
</template>